import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { LoadingService } from 'src/app/core/services/loader.service';
import { FinancialGoalService } from '../../financial-goal/services/financial-goal.service';
import { ConfirmationPromptComponent } from '../../repetaed-component/confirmation-prompt/confirmation-prompt.component';
import { UsersService } from '../services/users.service';

@Component({
  selector: 'app-withdraw-opportunity-popup',
  templateUrl: './withdraw-opportunity-popup.component.html',
  styleUrls: ['./withdraw-opportunity-popup.component.scss'],
})
export class WithdrawOpportunityPopupComponent implements OnInit {
  headline =
    'Provide the following information about why this opportunity is being closed.';
  applicationForm: FormGroup;
  events: any;
  todayDate: Date = new Date();
  statusCodes = [
    { id: 4, value: 'Application Declined' },
    { id: 5, value: 'Changed Mind' },
    { id: 955190000, value: 'Went to a Competitor' },
    { id: 955190001, value: 'Went direct to Bank' },
    // { id: 6, value: 'Went to a Competitor' },
    // { id: 7, value: 'Went direct to Bank' },
    // { id: 224400001, value: 'Went to a Competitor' },
    // { id: 224400002, value: 'Went direct to Bank' },
  ];
  public token;
  currentOppID: string;
  currentLeadFor: number;
  constructor(
    private _formBuilder: FormBuilder,
    private financeService: FinancialGoalService,
    private userService: UsersService,
    public auth: AuthenticationService,
    private loadingService: LoadingService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<WithdrawOpportunityPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}
  ngOnInit(): void {
    this.token = this.auth.getUserAccessToken();
    this.currentOppID = this.data.data;
    this.currentLeadFor = this.data.leadFor;
    this.applicationForm = this._formBuilder.group({
      opportunityid: [this.currentOppID],
      opportunitystatuscode: ['', [Validators.required]],
      // actualrevenue: ['', [Validators.required]],
      // actualend: [
      //   { value: this.todayDate, disabled: false },
      //   [Validators.required],
      // ],
      description: [''],
    });
  }

  onSubmit() {
    if (this.applicationForm.invalid) {
      this.auth.showSnackBarMsg('Please fill all details.', 9000);
      return;
    }
    const heading = 'Are you sure to delete ?';
    const dialogRef = this.dialog.open(ConfirmationPromptComponent, {
      width: '480px',
      data: {
        tagline: heading,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'OK') {
        this.loadingService.startLoading();
        this.financeService
          .disableOpportunity(this.token, this.applicationForm.value)
          .subscribe(
            (response) => {
              if (response.success) {
                this.removeOpportunityInUI(
                  this.applicationForm.value.opportunityid
                );
                this.loadingService.stopLoading();
                this.auth.showSnackBarMsg(response.data, 9000);
                this.dialogRef.close({ leadFor: this.currentLeadFor });
              } else {
                this.auth.showSnackBarMsg('Something went wrong!', 9000);
              }
            },
            (error) => {
              console.log(error);
              if (error.error.message.includes('Does Not Exist')) {
                this.removeOpportunityInUI(
                  this.applicationForm.value.opportunityid
                );
                this.auth.showSnackBarMsg(
                  'Opportunity withdrawn successfully.',
                  9000
                );
                this.dialogRef.close({ leadFor: this.currentLeadFor });
              } else {
                this.auth.showSnackBarMsg(error.error.message, 9000);
              }

              this.loadingService.stopLoading();
            }
          );
      }
    });
  }
  removeOpportunityInUI(oppId) {
    const allOpportunity = this.auth.getAllOpportunity();
    const oppafterRemove = [];
    allOpportunity.forEach((element) => {
      if (element.opportunityid !== oppId) {
        oppafterRemove.push(element);
      }
    });
    console.log('oppafterRemove');
    console.log(oppafterRemove);
    this.auth.setOpportunityinSession(oppafterRemove);
    if (this.currentLeadFor == 1) {
      this.auth.setCurrentSuperOpportunityId('');
      // this.router.navigate(['/']);
      this.auth.gotoUrl('/');
    }
    if (this.currentLeadFor == 2) {
      this.auth.setCurrentDebtOpportunityId('');
      // this.router.navigate(['financial-goal']);
      this.auth.gotoUrl('financial-goal');
    }
    if (this.currentLeadFor == 9) {
      this.auth.setCurrentInvestmentOpportunityId('');
      // this.router.navigate(['/']);
      this.auth.gotoUrl('/');
    }
    if (this.currentLeadFor == 4) {
      this.auth.setCurrentGeneralInsuranceOpportunityId('');
      // this.router.navigate(['/']);
      this.auth.gotoUrl('/');
    }
    if (this.currentLeadFor == 5) {
      this.auth.setCurrentHealthInsuranceOpportunityId('');
      // this.router.navigate(['/']);
      this.auth.gotoUrl('/');
    }
    if (this.currentLeadFor == 6) {
      this.auth.setCurrentEstatePlanningOpportunityId('');
      // this.router.navigate(['/']);
      this.auth.gotoUrl('/');
    }
    if (this.currentLeadFor == 7) {
      this.auth.setCurrentFinancialPlanningOpportunityId('');
      // this.router.navigate(['/']);
      this.auth.gotoUrl('/');
    }
    if (this.currentLeadFor == 3) {
      this.auth.setCurrentLifeInsuranceOpportunityId('');
      // this.router.navigate(['/']);
      this.auth.gotoUrl('/');
    }

    // this.auth.updateSideBar();
    this.auth.disableOpp.next(true);
    //  this.currentOpportunity = '';
    // this.toggleData(this.targetDiv);
  }
  addEvent(type: string, event: MatDatepickerInputEvent<Date>) {
    const date = Number(event.value.getMonth()) + 1;
    this.events =
      event.value.getFullYear() + '-' + date + '-' + event.value.getDate();
    // console.log(this.events);
  }

  /*
 get form control for validation
  */
  get applicationF() {
    return this.applicationForm.controls;
  }
}
